import { Button, Card, Container, Row, Col, Modal, Form } from "react-bootstrap";
import React, { useEffect, useCallback, useState } from "react";
import { allAnnonceFive } from "../../../Redux/annonceReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-multi-lang';
import { toast, ToastContainer } from "react-toastify";
import { verification, upadetConsentementUser, getDetailUser } from "../../../Redux/usersReduce";
import Configuration from "../../../configuration";
import MyCarousel from "../../../components/Caroussel/MyCarousel";
import jwt_decode from "jwt-decode";


// core components
function MesActualite({ client }) {
  const t = useTranslation();
  document.title = t("Actualite.mes");
  const dispatch = useDispatch();
  const deviceType = "desktop";
  let lang = window.localStorage.getItem("lang");
  var annee = localStorage.getItem("annee");
  const [entities, setEntities] = React.useState([]);
  const token = localStorage.getItem("x-access-token");
  const decoded = jwt_decode(token);
  const links = client + "/detailsActualite/";

  function formatDateDifference(dateString) {
    const currentDate = new Date();
    const publishedDate = new Date(dateString);

    const timeDifference = currentDate - publishedDate;
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    if (daysDifference === 0) {
      return t('Today');
    } else if (daysDifference === 1) {
      return t('Yesterday');
    } else {
      return t('daysAgo', { days: daysDifference });
    }
  }


  const ConsentModal = ({ show, updateConsentement, id_user }) => {
    const [consentement, setConsentement] = useState(0);

    return (
      <Modal show={show} >
        <Modal.Header >
          <Modal.Title><strong>Consentement et Validation</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Check>
              <Form.Check.Label>
                <Form.Check.Input
                  type="checkbox"
                  checked={consentement}
                  onChange={(v) => setConsentement(v.target.checked ? 1 : 0)}
                />
                <span className="form-check-sign"></span>
                <label>
                  En soumettant ce formulaire, vous acceptez que vos données soient
                  utilisées pour traiter votre commande conformément à notre
                  politique de confidentialité.Vous pouvez consulter via ce lien notre <a target="_blank" href="#"><strong>Politique de Confidentialité et respect des données des clients</strong></a>.

                </label>
              </Form.Check.Label>
            </Form.Check>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => updateConsentement(id_user, consentement)}>
            Valider
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const [showModal, setShowModal] = useState(true);
  const [userD, setUserD] = useState(null);

  const handleGetUserDetails = async (decoded) => {
    try {
      const result = await dispatch(getDetailUser(decoded.id));
      const userD = result.payload.data.user;
      setUserD(userD);
    } catch (error) {
      console.error("Error getting user details:", error);

    }
  };
  const notifyErr = (msg) =>
    toast.error(
      <strong>
        {msg}
      </strong>
    );

  const updateConsentement = async (id_user, consentement) => {
    try {
      if (consentement == 1) {
        var result = await dispatch(upadetConsentementUser({ id_user: id_user, consentement: consentement }));
        setShowModal(false)
      }
      else notifyErr("Consentement obligatoire!");
    } catch (error) {
      console.error("Error getting user details:", error);
    }
  };

  function ListTable({ list }) {
    return (
      <div className="list-table-container">

        {list.map((item, index) => (
          <a>

            <a key={index} className="list-item" href={links + item.id}>
              <div className=" text-center bloc-image">
                {item.image && (
                  <img
                    className="image-product"
                    src={Configuration.BACK_BASEURL + "annonce/" + item.image}
                    alt={item.titre}
                  />
                )}
              </div>
              <div className=" bloc-description">
                <div className="logo">
                  {/* Assuming you have a logo image URL in your data */}
                  <div className="titre-article groupe-logo" >
                    {/* <img
                    src={require("../../../assets/img/logo-actualite.png")}
                    alt="recordati"
                    className="logo-recordati"
                  /> */}
                    {client.replace('/', '').toUpperCase()}
                  </div>
                  <div className="date-pub">{formatDateDifference(item.date_pub)}</div>
                </div>
                <div className="clearfix"></div>
                <div className="titre-article">{lang == "en" ? item.titre_en : item.titre}</div>
                <div className="description-article">
                  {lang === "en" ? item.description_en.substring(0, 250) + '...' : item.description.substring(0, 150) + '...'}
                </div>

              </div>
              <div className="clearfix"></div>
            </a>
          </a>
        ))}
      </div>
    );
  }



  const getActualite = useCallback(async (titre) => {
    var actualite = await dispatch(allAnnonceFive({ type: 1, annee: annee, client }));
    setEntities(actualite.payload);
  }, [dispatch]);

  const verifToken = useCallback(async () => {
    try {
      await dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        } else {
          handleGetUserDetails(decoded);
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    getActualite()
  }, [getActualite]) //now shut up eslint
  return (
    <>
      <Container fluid className="style-actualita">
        <ToastContainer />
        {userD && userD.id_role == 6 && userD.consentement == 0 ? <ConsentModal show={showModal} updateConsentement={updateConsentement} id_user={userD.id} /> : null}
        <MyCarousel deviceType={deviceType} type={3} client={client} />
        <br></br>
        <Row>
          <Col md="12">

            {/*           
                <Card.Title as="h4"> {t("Actualite.mes")}</Card.Title>
           */}

            {entities.length > 0 ? <ListTable list={entities}></ListTable> : null}


          </Col>
        </Row>
      </Container>
    </>
  );
}

export default MesActualite;
